import { PiClockCounterClockwiseBold } from 'react-icons/pi';
import { useNavigate } from 'react-router-dom';

import icPeople from '@/assets/ic_people.svg';
import { Button } from '@/components';
import usePinsAccount from '@/hooks/usePinsAccount';
import useToast from '@/hooks/useToast';
import ROUTES from '@/router/routes';
import { ResponseMiCuenta } from '@/types/myAccount';

type MobileBottomActionsProps = {
  data: ResponseMiCuenta | undefined;
};

export const MobileBottomActions = ({ data }: MobileBottomActionsProps) => {
  const navigate = useNavigate();
  const toast = useToast();
  const { pinsData, handleSetPinsData } = usePinsAccount();

  const onClickMovementsButton = () => {
    if (data?.movimientos && data.movimientos?.length > 0) {
      navigate(ROUTES.movements);
    } else {
      toast.show('No tenés movimientos en tu cuenta.');
    }
  };

  return (
    <>
      {/* VER MOVIMIENTOS */}
      <Button
        className="w-full flex justify-center items-center gap-2 mt-4"
        type="button"
        variant="primary"
        onClick={onClickMovementsButton}
      >
        <PiClockCounterClockwiseBold size={20} />
        <span>Ver movimientos de mi cuenta</span>
      </Button>
      {/* TRANSFERIR SALDO */}
      <Button
        className="w-full flex justify-center items-center gap-2 mt-4"
        type="button"
        variant="secondary"
        onClick={() =>
          handleSetPinsData({ ...pinsData, showModalTransferBalance: true })
        }
      >
        <img src={icPeople} />
        <span>Transferí saldo a otro DT</span>
      </Button>
      {/* VER KIOSCOS */}
      <div className="text-center mt-4 mb-12">
        <Button
          className="text-gdt-blue underline underline-offset-4 font-bold cursor-pointer "
          href={ROUTES.virtualCharges}
          type="link"
          variant="text"
        >
          Ver kioscos con carga virtual
        </Button>
      </div>
    </>
  );
};
